import { loadStripe, type Stripe } from '@stripe/stripe-js';

const cache: Record<string, Promise<Stripe | null>> = {};

/** Memoized Stripe.js loader, keyed by publishable key. */
export function getStripe(publishableKey: string): Promise<Stripe | null> {
  if (!cache[publishableKey]) {
    cache[publishableKey] = loadStripe(publishableKey);
  }
  return cache[publishableKey];
}
